import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { filter, pipe, switchMap, tap } from 'rxjs';
import { CMSPaginatedResponse } from '../model/cms-response.model';
import { SpotifyLink } from '../model/spotify-link.model';
import { KnowledgeService } from '../service/knowledge.service';

export const SpotifyLinkStore = signalStore(
  withDevtools('spotify-link'),
  withState({
    data: null as CMSPaginatedResponse<SpotifyLink> | null,
  }),
  withRequestStatus(),
  withMethods((store, knowledgeService = inject(KnowledgeService)) => ({
    load: rxMethod<void>(
      pipe(
        filter(() => !store.isFulfilled()),
        tap(() => updateState(store, '[SpotifyLinkStore] Set pending', setPending())),
        switchMap(() =>
          knowledgeService.getSpotifyLinks().pipe(
            tapResponse({
              next: (data) => {
                updateState(store, '[SpotifyLinkStore] Set fulfilled', setFulfilled());
                updateState(store, '[SpotifyLinkStore] Set data', { data });
              },
              error: () => {
                updateState(store, '[SpotifyLinkStore] Set error', setError());
                updateState(store, '[SpotifyLinkStore] Set data', { data: null });
              },
            }),
          ),
        ),
      ),
    ),
  })),
);
